<template>
  <div class="app-bar-menu">
    <SurfaceNavBookmarkButton v-if="canILikeWall" />
    <li v-if="canIRemake">
      <a role="button" target="_blank" :href="remakeUrl" class="app-bar-button app-bar-icon-text-button">
        <base-icon name="remake" />
        <span class="responsive-no-phone-only">{{ __('Remake') }}</span></a
      >
    </li>
    <li>
      <a role="button" target="_blank" :href="shareUrl" class="app-bar-button app-bar-icon-text-button">
        <base-icon name="share_arrow" />
        <span class="responsive-no-phone-only">{{ __('Share') }}</span>
      </a>
    </li>
    <li>
      <a role="button" target="_blank" :href="showUrl" class="app-bar-button" :title="__('Open in new')">
        <base-icon name="open_in_new" />
      </a>
    </li>
  </div>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { mapGetters } from 'vuex'
import SurfaceNavBookmarkButton from 'vuecomponents/SurfaceNavBookmarkButton'
import BaseIcon from 'vuecomponents/base_icon'

export default {
  components: { BaseIcon, SurfaceNavBookmarkButton },
  computed: {
    ...mapGetters(['links', 'canIRemake', 'canILikeWall']),
    showUrl() {
      return this.links.show
    },
    remakeUrl() {
      return this.showUrl + '#remake'
    },
    shareUrl() {
      return this.showUrl + '#share'
    },
  },
}
</script>
